import React from "react";
import { string } from "prop-types";
import Button from "../../../Button";
import Link from "../../../Link";
import ButtonTheme from "../../../ButtonTheme";

export const FormSubmit = ({ submitQASelector = "", ...props }) => (
	<ButtonTheme
		Tag="button"
		type="submit"
		styleType="submit"
		data-qa-selector={submitQASelector}
		{...props}
	/>
);

FormSubmit.propTypes = {
	submitQASelector: string,
	...Button.propTypes,
};

export const FormSubmitV2 = ({ submitQASelector = "", ...props }) => (
	<ButtonTheme
		Tag="button"
		type="submit"
		styleType="submit"
		data-qa-selector={submitQASelector}
		{...props}
	/>
);

FormSubmitV2.propTypes = {
	submitQASelector: string,
	...Button.propTypes,
};

export const ButtonNextStepAccordion = ({ ...props }) => (
	<Button size="s" className="btn-block--sm button-form-next-step" {...props} />
);

ButtonNextStepAccordion.propTypes = {
	...Button.propTypes,
};

export const ButtonSubmitAccordion = ({ ...props }) => (
	<Button size="s" className="ml-1--md btn-block--sm" {...props} />
);

ButtonSubmitAccordion.propTypes = {
	...Button.propTypes,
};

export const LinkPreviousStepAccordion = ({ ...props }) => (
	<Link size="s" className="cursor--pointer" {...props} />
);

LinkPreviousStepAccordion.propTypes = {
	...Link.propTypes,
};
